import * as React from 'react'
import VehicleViewControlBarLayout from './VehicleViewControlBarLayout'

import useChangeVehicleParams from '../../hooks/useChangeVehicleParams'
import { useVehicles } from '@/modules/shared/context/vehicles/VehiclesContext'
import { withRouter } from '@/app/navigation/withRouter'

const VehicleBlocksBar: React.FC<any> = ({
  match,
  history,
  blocks = true,
}: {
  match: any
  history: any
  blocks: boolean
}) => {
  const { allVehicles } = useVehicles()
  const { goNextVehicleInActivity, goPrevVehicleInActivity } =
    useChangeVehicleParams()
  const { params } = match
  const { vehicleId } = params

  const vehicle = React.useMemo(
    () => allVehicles.find((v) => String(v.id) === String(vehicleId)) ?? null,
    [allVehicles, vehicleId],
  )

  const sortedIds = React.useMemo(
    () =>
      allVehicles
        .map((v) => String(v.id))
        .sort((a, b) => Number(a) - Number(b)),
    [allVehicles],
  )

  const numericId = vehicleId

  return (
    <VehicleViewControlBarLayout
      blockedView={blocks}
      registrationNumber={vehicle?.registrationNumber || ''}
      onPrev={() => goPrevVehicleInActivity({ sortedIds, numericId, history })}
      onNext={() => goNextVehicleInActivity({ sortedIds, numericId, history })}
    />
  )
}

export default withRouter(VehicleBlocksBar)
